import { Location } from "../types/weather.types"

const locations: Location[] = [
    {lat: 42.345548, lon: 43.277142, name: "Tsrikvali"},
    {lat: 41.719024, lon: 44.786648, name: "Tbilisi"},
    {lat: 42.267241, lon: 42.709247, name: "Kutaisi"}
]

export {locations}